import { fetchAttachmentDownloadUrl } from '../components/attachments';

const ATTACHMENT_REFERENCE_DOWNLOAD_ERRORS = {
    downloadUrlErrorMessage: 'The attachment reference download URL operation failed.'
} as const;

export class AttachmentReferenceDownloadUrlError extends Error {
    constructor(message?: string) {
        super(message || ATTACHMENT_REFERENCE_DOWNLOAD_ERRORS.downloadUrlErrorMessage);
        this.name = 'AttachmentReferenceDownloadUrlError';
    }
}

export const getAttachmentReferenceDownloadUrl = async (
    referenceId: string,
    activeOrganizationAccount: string
): Promise<string | undefined> => {
    try {
        return await fetchAttachmentDownloadUrl(referenceId, activeOrganizationAccount);
    } catch (error) {
        throw new AttachmentReferenceDownloadUrlError(
            error instanceof Error ? error.message : ATTACHMENT_REFERENCE_DOWNLOAD_ERRORS.downloadUrlErrorMessage
        );
    }
};
